import { Modal } from 'antd'
import { useEffect } from 'react'
import { reportUiError } from '../../monitoring/glitchtip'

export const useErrorModal = (
    state: { isError?: boolean; error?: any; [key: string]: any },
    title: string
) => {
    // const [modal, contextHolder] = Modal.useModal()

    useEffect(() => {
        if (state.isError) {
            reportUiError(title, state.error)
            Modal.error({
                title,
                content: state.error ? JSON.stringify(state.error) : undefined,
                footer: 'Пожалуйста, обратитесь к администратору. Отправьте скриншот ошибки на почту ryzhakov.r@mail.ru.',
            })
        }
    }, [state.isError, state.error, title])

    // return contextHolder
}

export default useErrorModal
